export default {
  form: {
    owner_phone_number: {
      label: 'Numer telefonu osoby kontaktowej',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail osoby kontaktowej',
      placeholder: 'Wprowadź e-mail',
    },
    owner_first_name: {
      label: 'Imię',
      placeholder: 'Wprowadź imię',
    },
    owner_last_name: {
      label: 'Nazwisko',
      placeholder: 'Wprowadź nazwisko',
    },
    owner_dob: {
      label: 'Data urodzenia',
      placeholder: 'Data',
    },
    owner_id_number: {
      label: 'Numer ID (np. numer ubezpieczenia społecznego w USA)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Wstecz',
    next: 'Dalej',
  },
};
